import React, { useState } from 'react';

const IzinTalepFormu = () => {
  const [formData, setFormData] = useState({
    izinTuru: '',
    baslangicTarihi: '',
    bitisTarihi: '',
    aciklama: ''
  });

  const [errors, setErrors] = useState({});

  const izinTurleri = [
    { value: 'yillik-izin', label: 'Yıllık İzin' },
    { value: 'mazeret-izni', label: 'Mazeret İzni' },
    { value: 'rapor', label: 'Rapor' },
    { value: 'dogum-izni', label: 'Doğum İzni' },
    { value: 'babalik-izni', label: 'Babalık İzni' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.izinTuru) {
      newErrors.izinTuru = 'İzin türü seçimi zorunludur';
    }

    if (!formData.baslangicTarihi) {
      newErrors.baslangicTarihi = 'Başlangıç tarihi zorunludur';
    }

    if (!formData.bitisTarihi) {
      newErrors.bitisTarihi = 'Bitiş tarihi zorunludur';
    }

    if (formData.baslangicTarihi && formData.bitisTarihi) {
      const startDate = new Date(formData.baslangicTarihi);
      const endDate = new Date(formData.bitisTarihi);
      
      if (endDate < startDate) {
        newErrors.bitisTarihi = 'Bitiş tarihi başlangıç tarihinden önce olamaz';
      }
    }

    if (!formData.aciklama.trim()) {
      newErrors.aciklama = 'Açıklama alanı zorunludur';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      console.log('Form gönderiliyor:', formData);
      // Here you would typically send the data to your backend
      alert('İzin talebiniz başarıyla gönderildi!');
      
      // Reset form
      setFormData({
        izinTuru: '',
        baslangicTarihi: '',
        bitisTarihi: '',
        aciklama: ''
      });
    }
  };

  const calculateDays = () => {
    if (formData.baslangicTarihi && formData.bitisTarihi) {
      const startDate = new Date(formData.baslangicTarihi);
      const endDate = new Date(formData.bitisTarihi);
      const diffTime = Math.abs(endDate - startDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
      return diffDays;
    }
    return 0;
  };

  return (
    <div className="box">
      <div className="box-header">
        <h4 className="card-title">İzin Talep Formu</h4>
        <p className="text-muted">İzin talebinizi oluşturmak için formu doldurun</p>
      </div>
      <div className="box-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label htmlFor="izinTuru" className="form-label">
                İzin Türü <span className="text-danger">*</span>
              </label>
              <select
                id="izinTuru"
                name="izinTuru"
                className={`form-select ${errors.izinTuru ? 'is-invalid' : ''}`}
                value={formData.izinTuru}
                onChange={handleInputChange}
              >
                <option value="">İzin türü seçiniz...</option>
                {izinTurleri.map((tur) => (
                  <option key={tur.value} value={tur.value}>
                    {tur.label}
                  </option>
                ))}
              </select>
              {errors.izinTuru && (
                <div className="invalid-feedback">{errors.izinTuru}</div>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">İzin Süresi</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bx bx-calendar"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  value={calculateDays() > 0 ? `${calculateDays()} gün` : ''}
                  readOnly
                  placeholder="Tarihleri seçtiğinizde hesaplanacak"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label htmlFor="baslangicTarihi" className="form-label">
                Başlangıç Tarihi <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                id="baslangicTarihi"
                name="baslangicTarihi"
                className={`form-control ${errors.baslangicTarihi ? 'is-invalid' : ''}`}
                value={formData.baslangicTarihi}
                onChange={handleInputChange}
                min={new Date().toISOString().split('T')[0]}
              />
              {errors.baslangicTarihi && (
                <div className="invalid-feedback">{errors.baslangicTarihi}</div>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label htmlFor="bitisTarihi" className="form-label">
                Bitiş Tarihi <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                id="bitisTarihi"
                name="bitisTarihi"
                className={`form-control ${errors.bitisTarihi ? 'is-invalid' : ''}`}
                value={formData.bitisTarihi}
                onChange={handleInputChange}
                min={formData.baslangicTarihi || new Date().toISOString().split('T')[0]}
              />
              {errors.bitisTarihi && (
                <div className="invalid-feedback">{errors.bitisTarihi}</div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-12 mb-3">
              <label htmlFor="aciklama" className="form-label">
                Açıklama <span className="text-danger">*</span>
              </label>
              <textarea
                id="aciklama"
                name="aciklama"
                className={`form-control ${errors.aciklama ? 'is-invalid' : ''}`}
                rows="4"
                placeholder="İzin sebebinizi detaylı olarak açıklayın..."
                value={formData.aciklama}
                onChange={handleInputChange}
              ></textarea>
              {errors.aciklama && (
                <div className="invalid-feedback">{errors.aciklama}</div>
              )}
              <div className="form-text">
                Minimum 10 karakter gereklidir. {formData.aciklama.length}/500
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="d-flex justify-content-between">
                <button type="button" className="btn btn-secondary">
                  <i className="bx bx-x me-1"></i>
                  İptal
                </button>
                <button type="submit" className="btn btn-primary">
                  <i className="bx bx-send me-1"></i>
                  İzin Talebini Gönder
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default IzinTalepFormu; 